import { DaymapQuery as s } from "../daymapQuery.js";
var n;
((e) => {
  class u extends s {
    constructor(t) {
      super(
        ["student", t.studentId],
        t,
        `/lms/api/student/${t.studentId}`,
        null
      );
    }
  }
  e.get = u;
  class l extends s {
    constructor(t) {
      super(
        ["indicators", t.studentId],
        t,
        `/lms/api/student/${t.studentId}/indicators`,
        null,
        {
          stale: 1e3 * 60
        }
      );
    }
  }
  e.indicators = l;
  class c extends s {
    constructor(t) {
      const d = [];
      t.classId && d.push(`classId=${t.classId}`), t.year && d.push(`year=${t.year}`);
      const $ = d.length > 0 ? `?${d.join("&")}` : "";
      super(
        ["studentAttendanceRates", t.studentId, t.classId, t.year],
        t,
        `/lms/api/student/attendancerates/${t.studentId}${$}`,
        null,
        {
          stale: 1e3 * 60 * 5,
          retry: 0
        }
      );
    }
  }
  e.getAttendanceRates = c;
  class r extends s {
    constructor(t) {
      super(
        ["yearsandclasses", t.studentId],
        t,
        `/lms/api/student/data?studentId=${t.studentId}`,
        null,
        {
          stale: 1e3 * 60 * 60
        }
      );
    }
  }
  e.YearsAndClasses = r;
  class i extends s {
    constructor(t) {
      super(
        ["dataForStudent", t.studentId],
        t,
        `/lms/api/student/data?studentId=${t.studentId}`,
        null,
        { stale: 1e3 * 60 * 10 }
        // 10 minutes
      );
    }
  }
  e.DataForStudent = i;
  class I extends s {
    constructor(t) {
      super(
        ["classesByYear", t.studentId, t.year, t.current],
        t,
        `/lms/api/student/classesbyyear?studentId=${t.studentId}&year=${t.year}&current=${t.current ? 1 : 0}`,
        null,
        {
          stale: 1e3 * 60 * 60,
          enabled: t.enabled
        }
      );
    }
  }
  e.ClassesByYear = I;
  class y extends s {
    constructor(t) {
      super(
        ["studentDayPeriods", t.studentId, t.date.toDateString()],
        t,
        `/lms/api/day/student/${t.studentId}/periods?date=${t.date.toISOString()}`,
        null,
        {
          stale: 1e3 * 60 * 20
          // 20 minutes
        }
      );
    }
  }
  e.GetStudentPeriodDay = y;
})(n || (n = {}));
export {
  n as student
};
//# sourceMappingURL=index.js.map
